package com.cybersoftsolution.cybersoftsolutionweb.models

import kotlinx.serialization.Serializable

@Serializable
open class MyElement (
    open var id: String? = "",
    open var text: String = "",
    open var visible: Boolean = true,
    open var selected: Boolean = false

)